"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSort = void 0;
const react_1 = require("react");
const sortable_1 = require("@dnd-kit/sortable");
// sort items using a separate order state
function useSort(items, getId) {
    const [order, setOrder] = (0, react_1.useState)([]);
    const key = (0, react_1.useMemo)(() => {
        return items.map(item => getId(item)).join(',');
    }, [items, getId]);
    const sorted = (0, react_1.useMemo)(() => {
        return items.slice().sort((a, b) => {
            const aId = getId(a);
            const bId = getId(b);
            const aIndex = order.findIndex(id => id === aId);
            const bIndex = order.findIndex(id => id === bId);
            return bIndex < 0 ? -1 : aIndex - bIndex;
        });
    }, [items, order, getId]);
    const findIndex = (0, react_1.useCallback)((id) => order.indexOf(id), [order]);
    const reorder = (0, react_1.useCallback)((sourceId, targetId) => {
        // reorder conditions
        setOrder(order => {
            const sourceIndex = order.indexOf(sourceId);
            const targetIndex = order.indexOf(targetId);
            return (0, sortable_1.arrayMove)(order, sourceIndex, targetIndex);
        });
    }, []);
    // when items change, update order
    (0, react_1.useEffect)(() => {
        setOrder(items.map(item => getId(item)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
    const sort = (0, react_1.useMemo)(() => {
        return { items: sorted, findIndex, reorder };
    }, [sorted, findIndex, reorder]);
    return sort;
}
exports.useSort = useSort;
//# sourceMappingURL=useSort.js.map